module.exports = __webpack_public_path__ + "img/new1.2a6bf13e.png";